/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import api from 'api';
import { Store, UpdateStore } from 'StoreContext';
import {
  Card,
  CardHeader,
  Button,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  Container,
  Row,
} from 'reactstrap';
import { ReactComponent as Edit } from "../../assets/img/EditIcon.svg"
import { ReactComponent as Del } from "../../assets/img/delIcon.svg"
import { MenuItem, Pagination, PaginationItem, Select } from "@mui/material";
import ArrowBack from "../../assets/LeftArrow.svg";
import { ReactComponent as Arrow } from "../../assets/img/Arrowdown.svg"
import ArrowForward from "../../assets/RIghtArrow.svg";


// core components
import AddUser from './AddBrand';
import EditBrand from './EditBrand';
import { toast } from 'react-toastify';
// import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';
import { getMediaUrl } from '../../config';
import Spinner from 'components/Spinner/Spinner';
import moment from 'moment';
import { Avatar } from '@mui/material';
import { inputStyle } from 'views/Orders/CreateOrder';
import CreateBrand from './CreateBrand';
import EditBrandModal from './EditBrandModal';
import ConfirmationModal from 'components/Common/ConfirmationModal';
import VerificationModal from 'components/Common/VerificationModal';
import SearchBar from 'components/Common/SearchBar';
import ResetPassword from './ResetPassword';

const DeleteBrandModal = ({ brandName, handleModal, handleConfirm, loading }) => {
  const [typed, setTyped] = React.useState('');
  const matches = typed === brandName;
  return (
    <div style={{ fontFamily: "Outfit", position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 1050, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
      <div style={{ backgroundColor: "#fff", borderRadius: "20px", padding: "30px", width: "440px", textAlign: "center" }}>
        <div style={{
          width: "70px", height: "70px", borderRadius: "50%",
          backgroundColor: "rgba(220, 38, 38, 0.1)", display: "flex",
          alignItems: "center", justifyContent: "center", margin: "0 auto 16px",
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </div>
        <h2 style={{ fontFamily: "Outfit", fontWeight: 700, fontSize: "22px", color: "#dc2626", marginBottom: "8px" }}>
          Delete Brand
        </h2>
        <div style={{
          backgroundColor: "#FEF2F2", border: "1px solid #FECACA",
          borderRadius: "10px", padding: "14px", marginBottom: "16px", textAlign: "left",
        }}>
          <p style={{ color: "#991B1B", fontSize: "14px", fontWeight: 600, margin: "0 0 6px 0", fontFamily: "Outfit" }}>
            This will permanently delete:
          </p>
          <ul style={{ color: "#7F1D1D", fontSize: "13px", margin: 0, paddingLeft: "18px", fontFamily: "Outfit", lineHeight: "1.6" }}>
            <li>All orders and batches</li>
            <li>All generated codes</li>
            <li>Scan history and analytics</li>
            <li>Reward products and redemptions</li>
          </ul>
        </div>
        <p style={{ color: "#555", fontSize: "14px", fontFamily: "Outfit", marginBottom: "8px" }}>
          Type <strong style={{ color: "#dc2626" }}>{brandName}</strong> to confirm
        </p>
        <input
          type="text"
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && matches && handleConfirm()}
          placeholder={brandName}
          autoFocus
          style={{
            backgroundColor: "#F3F3F3",
            border: matches ? "2px solid #dc2626" : "2px solid transparent",
            borderRadius: "8px",
            fontFamily: "Outfit",
            width: "100%",
            padding: "12px 17px",
            fontSize: "16px",
            textAlign: "center",
            marginBottom: "20px",
            outline: "none",
            transition: "border-color 0.2s",
          }}
        />
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button className="vs-btn-cancel" onClick={handleModal} style={{ width: "45%" }}>
            Cancel
          </button>
          <button
            className="vs-btn-save"
            onClick={handleConfirm}
            disabled={!matches || loading}
            style={{
              width: "45%",
              backgroundColor: matches ? "#dc2626" : "#ccc",
              cursor: matches ? "pointer" : "not-allowed",
              transition: "background-color 0.2s",
            }}
          >
            {loading ? "Deleting..." : "Delete Brand"}
          </button>
        </div>
      </div>
    </div>
  );
};


const Brands = () => {
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [verifcationModal, setVerificationModal] = useState(false);
  const [confirmDeactivate, setConfirmDeactivate] = useState(false);
  const [loading, setLoading] = useState(false);
  const store = Store();
  const { brands, brandRecords } = store;
  const adminUser = store.user;
  const [filterBrands, setFilterBrands] = useState([]);
  const [search, setSearch] = useState();
  const updateStore = UpdateStore();
  const history = useHistory();
  const [user, setUser] = useState({
    _id: '',
    name: '',
    email: '',
    url: '',
    logo: '',
    websiteLink: '',
    logoWidth: '',
    preferences: {
      color: '#000000',
      secondaryColor: 'black',
    },
  });
  const [fileName, setFileName] = useState('');
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const [hasMore, setHasMore] = useState(true);
  const brandSentinelRef = React.useRef(null);

  const handleChange = (e) => {
    setSearch(e.target.value)
  }

  const getUsers = async (pageNum, append) => {
    try {
      setLoading(true);
      const data = await api('get', `/users?role=brand&page=${pageNum || page}&pageSize=${pageSize}`);
      const newBrands = data.users || [];
      if (append) {
        setFilterBrands(prev => [...prev, ...newBrands]);
        updateStore({ brands: [...(filterBrands || []), ...newBrands], brandRecords: data.totalRecords });
      } else {
        setFilterBrands(newBrands);
        updateStore({ brands: newBrands, brandRecords: data.totalRecords });
      }
      setHasMore(newBrands.length >= pageSize);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleModal = () => {
    setOpenModal((open) => !open);
    return openModal;
  };


  const handlResetModal = (item) => {
    if (!item?.email) {
      toast.error('Portal access disabled — add an email to this brand first');
      return;
    }
    setUser({
      _id: item?._id,
      name: item?.name,
    });
    setResetPassword((open) => !open);
    return openModal;
  };

  const handleEditModal = (item) => {
    console.log("item11", item)
    if (item) {
      setUser({
        _id: item._id,
        name: item.name,
        email: item.email,
        url: item.url,
        websiteLink: item.websiteLink ? item.websiteLink : '',
        logo: item.preferences?.logo,
        logoWidth: item.logoWidth ? item.logoWidth : '',
        websiteLink: item?.websiteLink ? item?.websiteLink : "",
        enableReward: item?.enableReward ? item?.enableReward : false,
        preferences: {
          color: item?.preferences?.color,
          secondaryColor: item?.preferences?.secondaryColor,
          logo: item.preferences?.logo,
        },
      });
      setFileName(item?.preferences?.logo ? getMediaUrl(item?.preferences?.logo) : '');
    }
    setEditModal((open) => !open);
    return openModal;
  };
  const LoginAsBrand = (item) => {
    setLoading(true);
    let uIs = { brandId: item._id, email: item.email, twoFactor: true }

    api('post', '/auth/login/asbrand', uIs)
      .then((res) => {
        if (res.token) {
          setLoading(false);
          const { user } = res;
          localStorage.setItem('Brandtoken', res.token);

          window.location = `/brand/index`;

        }
      })
      .catch((err) => {
        setLoading(false);
        console.log('Error ', err);
      });
  };


  const handleConfirmModal = () => {
    setConfirmModal((prev) => !prev);
  };

  const handleConfirmDeactivation = () => {
    setConfirmDeactivate((prev) => !prev);
  };

  const handleActive = () => {
    if (user._id) {
      setLoading(true);
      api('patch', `/users/change-status/${user?._id}`)
        .then((res) => {
          toast.success(res?.message);
          getUsers();
          setLoading(false);
          handleConfirmDeactivation();
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      toast.error('Please select brand');
    }
  };

  const handleDeleteBrand = (item) => {
    setUser({
      _id: item._id,
      name: item.name,
    });
    handleConfirmModal();
  };
  const handleDeactivateBrand = (item) => {
    setUser({
      _id: item._id,
      name: item.name,
      active: item.active,
    });
    handleConfirmDeactivation();
  };

  const handleDelete2 = () => {
    if (user?._id) {
      setLoading(true);
      api('delete', `/users/admin/${user._id}`)
        .then(() => {
          toast.success('Brand deleted successfully');
          handleConfirmModal();
          getUsers();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      toast.error('Please select brand');
    }
  };
  const handleDelete = () => {
    if (user?._id) {
      setLoading(true);
      api('post', `/auth/sendVerificationCode`, { email: adminUser?.email })
        .then(() => {
          toast.success('OTP sent successfully');
          handleConfirmModal();
          setVerificationModal(true)
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err?.response?.data?.message || 'Failed to send verification code');
        });


    } else {
      toast.error('Please select brand');
    }
  };
  const handlVerificationModal = () => {
    setVerificationModal((open) => !open);
    return verifcationModal;
  };
  const handleConfirmVerification = (otp) => {
    if (user?._id) {
      setLoading(true);
      api('delete', `/users/admin/${user._id}/${otp}`)
        .then(() => {
          toast.success('Brand deleted successfully');
          handlVerificationModal();
          getUsers();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      toast.error('Please select brand');
    }
  };
  const handleResendCode = () => {
    console.log("resend Code")

  };
  const HandleResendInvitaion = (user) => {
    if (user?._id) {
      setLoading(true);
      api('put', `/users/brand/invitaion/${user._id}`)
        .then(() => {
          toast.success('Resend Invitation successfully');
          getUsers();
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      toast.error('Please select brand');
    }

  }
  const checkInvitaionTime = (item) => {
    console.log("checkInvitaionTime", item.updatedAt)
    return true
  }

  useEffect(() => {
    getUsers(page, page > 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    if (!brandSentinelRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          setPage(p => p + 1);
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(brandSentinelRef.current);
    return () => observer.disconnect();
  }, [hasMore, loading]);

  useEffect(() => {
    if (search) {
      const filtered = filterBrands?.filter(item =>
        item?.name?.toLowerCase().includes(search.toLowerCase())
      );
      setFilterBrands(filtered);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <>
      <Container fluid>
        {loading && <Spinner />}
        {/* Table */}

        {/* {loading && <Spinner />} */}

        <div className='d-flex justify-content-between align-items-center pb-4 '>
          <h1 className="vs-page-title">Brands Management</h1>
          <button
            onClick={handleModal}
            className='vs-btn-create'>
            Create Brand
          </button>
        </div>
        <SearchBar handleChange={handleChange} customClass='pb-4' />
        {/* Table */}




        <div className="d-none d-md-block">
        <Table style={{ fontFamily: 'Outfit', tableLayout: 'fixed', width: '100%' }} className='align-items-center table-flush'>
          <colgroup>
            <col style={{ width: '18%' }} />
            <col style={{ width: '22%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '36%' }} />
          </colgroup>
          <thead className='thead-light'>
            <tr>
              <th style={{
                borderTopLeftRadius: "10px",
                borderTop: 'none',
                background: 'white',
                fontSize: '13px',
                fontWeight: 600,
                color: '#1C1C1C',
                textTransform: "capitalize",
                letterSpacing: 0,
                padding: '10px 8px',
              }} scope='col'>Brand</th>
              <th style={{
                borderTop: 'none',
                background: 'white',
                fontSize: '13px',
                fontWeight: 600,
                color: '#1C1C1C',
                textTransform: "capitalize",
                letterSpacing: 0,
                padding: '10px 8px',
              }} scope='col'>Email</th>
              <th style={{
                borderTop: 'none',
                background: 'white',
                textAlign: 'center',
                fontSize: '13px',
                fontWeight: 600,
                color: '#1C1C1C',
                textTransform: "capitalize",
                letterSpacing: 0,
                padding: '10px 8px',
              }} scope='col'>Status</th>
              <th style={{
                borderTop: 'none',
                background: 'white',
                fontSize: '13px',
                fontWeight: 600,
                color: '#1C1C1C',
                textTransform: "capitalize",
                letterSpacing: 0,
                padding: '10px 8px',
              }} scope='col'>Created</th>
              <th style={{
                borderTop: 'none',
                background: 'white',
                fontSize: '13px',
                fontWeight: 600,
                color: '#1C1C1C',
                textTransform: "capitalize",
                borderTopRightRadius: "10px",
                letterSpacing: 0,
                padding: '10px 8px',
              }} scope='col'>Actions</th>


            </tr>
          </thead>
          <tbody>
            {filterBrands?.map((item) => {
              return (
                <tr style={{
                  fontFamily: "Outfit",
                  color: '#1C1C1C',
                }}
                  className='bg-white'>
                  <td scope='row'>

                    <span className='mb-0 text-sm'>
                      {item.name?.length > 30
                        ? item.name?.substring(0, 30) + '...'
                        : item.name}
                    </span>

                  </td>
                  <td title={item.email || 'No email set'}>
                    {item.email
                      ? (item.email.length > 30 ? item.email.substring(0, 30) + '...' : item.email)
                      : <span style={{ color: '#aaa', fontStyle: 'italic' }}>No email</span>}
                  </td>
                  <td className=' text-center'>
                    <div className='rounded-pill d-flex justify-content-center align-items-center px-3 py-1'
                      style={{
                        backgroundColor: item.active ? "rgba(0, 178, 7, 0.1)" : 'rgba(255, 1, 1, 0.1)',
                      }}>
                      <span style={{
                        color: item.active ? '#00B207' : '#FF0101',
                        fontSize: '12px',
                        fontWeight: 400
                      }} >
                        {item.active ? 'Active' : 'Deactivated'}
                      </span>
                    </div>

                  </td>


                  <td style={{ padding: '10px 8px', fontSize: '13px' }}>{moment(item.createdAt).format('MMM DD, YYYY')}</td>

                  <td className='d-flex' style={{
                    gap: '10px', padding: '10px 8px',
                  }}>
                    <div style={{ gap: "8px" }} className='d-flex align-items-center'>
                      {item.websiteLink ? (
                        <a href={item.websiteLink.startsWith('http') ? item.websiteLink : `https://${item.websiteLink}`} target="_blank" rel="noreferrer" title={`Visit ${item.websiteLink}`} style={{ display: "inline-flex", alignItems: "center" }}>
                          <i className="ni ni-world-2" style={{ cursor: "pointer", color: "#362FD8", fontSize: "16px" }} />
                        </a>
                      ) : (
                        <i className="ni ni-world-2" style={{ cursor: "default", color: "#ccc", fontSize: "16px", display: "inline-flex", alignItems: "center" }} title="No domain set" />
                      )}
                      <span className="vs-action-icon" title="Edit brand">
                        <Edit onClick={() => handleEditModal(item)} />
                      </span>
                      <span className="vs-action-icon destructive" title="Delete brand">
                        <Del onClick={() => handleDeleteBrand(item)} />
                      </span>
                    </div>
                    <div style={{ gap: "6px" }} className='d-flex'>
                      <button
                        onClick={() => handleDeactivateBrand(item)}
                        className='vs-btn-outline-pill'
                        title={item.active ? 'Deactivate this brand' : 'Activate this brand (no email required)'}
                        style={item.active
                          ? { fontSize: '12px', padding: '4px 10px', color: '#dc3545', borderColor: '#dc3545' }
                          : { fontSize: '12px', padding: '4px 10px', color: '#fff', backgroundColor: '#00B207', borderColor: '#00B207' }}>
                        {item.active ? 'Deactivate' : 'Activate'}
                      </button>
                      <button
                        onClick={() => handlResetModal(item)}
                        className='vs-btn-outline-pill'
                        disabled={!item.email}
                        title={!item.email ? 'Portal access disabled — add email to brand' : 'Reset brand password'}
                        style={!item.email ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'auto', fontSize: '12px', padding: '4px 10px' } : { fontSize: '12px', padding: '4px 10px' }}>Reset</button>
                      <button
                        onClick={() => { LoginAsBrand(item) }}
                        className='vs-btn-outline-pill'
                        disabled={!item.email}
                        title={!item.email ? 'Portal access disabled — add email to brand' : 'Login as this brand'}
                        style={!item.email ? { opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'auto', fontSize: '12px', padding: '4px 10px' } : { fontSize: '12px', padding: '4px 10px' }}>Login</button>
                    </div>
                  </td>
                </tr>
              )
            })}

          </tbody>
        </Table>
        </div>

        {/* Mobile Cards */}
        <div className="d-block d-md-none" style={{ fontFamily: 'Outfit' }}>
          {filterBrands?.map((item) => {
            const isDeactivated = !item.active;
            return (
              <div key={item._id} style={{
                backgroundColor: '#fff', borderRadius: '10px', padding: '14px 16px',
                marginBottom: '10px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                opacity: isDeactivated ? 0.5 : 1,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {item.preferences?.logo && (
                      <img src={getMediaUrl(item.preferences.logo)} alt="" style={{ width: 28, height: 28, borderRadius: '6px', objectFit: 'cover' }} />
                    )}
                    <span style={{ fontWeight: 600, fontSize: '14px', color: '#1C1C1C' }}>{item.name}</span>
                  </div>
                  <span style={{
                    padding: '2px 8px', borderRadius: '10px', fontSize: '10px', fontWeight: 500,
                    backgroundColor: isDeactivated ? 'rgba(220,53,69,0.08)' : 'rgba(0,178,7,0.08)',
                    color: isDeactivated ? '#dc3545' : '#00B207',
                  }}>{isDeactivated ? 'Deactivated' : 'Active'}</span>
                </div>
                <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                  {item.email || <span style={{ fontStyle: 'italic', color: '#aaa' }}>No email</span>}
                </div>
                {item.url && (
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '6px' }}>URL: {item.url}</div>
                )}
                <div style={{ fontSize: '11px', color: '#999', marginBottom: '8px' }}>
                  Joined {moment(item.createdAt).fromNow()}
                </div>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <span style={{ cursor: 'pointer', fontSize: '12px', color: '#362FD8' }} onClick={() => handleEditModal(item)}>Edit</span>
                  <span style={{ cursor: 'pointer', fontSize: '12px', color: '#362FD8' }} onClick={() => LoginAsBrand(item)} >{item.email ? 'Login as Brand' : ''}</span>
                  <span style={{ cursor: 'pointer', fontSize: '12px', color: '#362FD8' }} onClick={() => handlResetModal(item)}>{item.email ? 'Reset Password' : ''}</span>
                  <span style={{ cursor: 'pointer', fontSize: '12px', color: isDeactivated ? '#00B207' : '#dc3545' }}
                    onClick={() => handleDeactivateBrand(item)}>
                    {isDeactivated ? 'Activate' : 'Deactivate'}
                  </span>
                  <span style={{ cursor: 'pointer', fontSize: '12px', color: '#dc3545' }} onClick={() => handleDeleteBrand(item)}>Delete</span>
                </div>
              </div>
            );
          })}
        </div>

        <div ref={brandSentinelRef} style={{ height: '1px' }} />
        {loading && (
          <div style={{ textAlign: 'center', padding: '16px', fontFamily: 'Outfit', color: '#888', fontSize: '13px' }}>Loading more...</div>
        )}
        {!hasMore && filterBrands?.length > 0 && (
          <div style={{ textAlign: 'center', padding: '12px', fontFamily: 'Outfit', color: '#aaa', fontSize: '12px' }}>All brands loaded</div>
        )}


        {/* <Row>
          <div className='col'>
            <Card className='shadow'>
              <CardHeader className='border-0'>
                <div className='d-flex justify-content-between '>
                  <h3 className='mb-0'>Brands</h3>
                  <Button color='primary' onClick={handleModal} size='md'>
                    <i className='ni ni-fat-add'></i>
                    Add brand
                  </Button>
                </div>
              </CardHeader>
              <Table className='align-items-center table-flush' responsive>
                <thead className='thead-light'>
                  <tr>

                    <th scope='col'>Name</th>
                    <th scope='col'>Email</th>
                    <th scope='col'>Brand Id</th>
                    <th scope='col'>Active</th>
                    <th scope='col'>Status</th>
                    <th scope='col'>Created At</th>
                    <th scope='col' />
                  </tr>
                </thead>
                <tbody>
                  {brands?.map((item) => {
                    return (
                      <tr>


                        <th scope='row'>
                          <Media className='align-items-center'>
                            <Media>
                              <span className='mb-0 text-sm' title={item.name}>
                                {item.name?.length > 30
                                  ? item.name?.substring(0, 30) + '...'
                                  : item.name}
                              </span>
                            </Media>
                          </Media>
                        </th>
                        <td title={item.email || 'No email set'}>
                          {item.email
                            ? (item.email.length > 30 ? item.email.substring(0, 30) + '...' : item.email)
                            : <span style={{ color: '#aaa', fontStyle: 'italic' }}>No email</span>}
                        </td>
                        <td title={item._id}>
                          {item._id}

                        </td>


                        <td>{item.active ? 'Active' : 'Deactivated'}</td>
                        <td>{item.invitationStatus.charAt(0).toUpperCase() + item.invitationStatus.slice(1)}</td>

                        <td>{moment(item.createdAt).format('MMMM DD, yyyy hh:mm A')}</td>
                        <td className='text-right'>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className='btn-icon-only text-light'
                              role='button'
                              size='sm'
                              // color=''
                              onClick={(e) => e.preventDefault()}
                            >
                              <i className='fas fa-ellipsis-v' />
                            </DropdownToggle>
                            <DropdownMenu className='dropdown-menu-arrow' right>
                              {<DropdownItem onClick={() => LoginAsBrand(item)}>
                                Login as
                              </DropdownItem>}

                              {
                                item?.
                                  invitationStatus == 'accepted' ? <>

                                </> : <>{checkInvitaionTime(item) ? <DropdownItem onClick={() => HandleResendInvitaion(item)}>
                                  Resend Invitation
                                </DropdownItem> : <DropdownItem onClick={() => HandleResendInvitaion(item)}>
                                  Resend Invitation
                                </DropdownItem>} </>
                              }
                              <DropdownItem onClick={() => handleEditModal(item)}>
                                Edit
                              </DropdownItem>
                              <DropdownItem
                                className={item.active ? 'text-danger' : 'text-success'}
                                onClick={() => handleActive(item?._id)}
                              >
                                {item.active ? 'De-activate' : 'Activate'}
                              </DropdownItem>
                              <DropdownItem
                                className='text-danger'
                                onClick={() => handleDeleteBrand(item)}
                              >
                                Delete
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown >
                        </td >
                      </tr >
                    );
                  })}
                </tbody >
              </Table >
            </Card >
          </div >
        </Row > */}

        {/* <ConfirmModal
          handleModal={handleConfirmModal}
          openModal={confirmModal}
          description={`You are about delete ${user?.name}, all data linked with this brand will be deleted
            permanently.`}
          heading='Delete brand'
          handleSubmit={handleDelete}
          loading={loading}
        /> */}
        {confirmModal && <DeleteBrandModal
          brandName={user?.name}
          handleModal={handleConfirmModal}
          handleConfirm={handleDelete}
          loading={loading}
        />}

        {confirmDeactivate && <ConfirmationModal
          handleModal={handleConfirmDeactivation}
          heading={user?.active ? 'Deactivate Brand' : 'Activate Brand'}
          message={user?.active
            ? `Are you sure you want to deactivate ${user?.name || 'this brand'}?`
            : `Activate ${user?.name || 'this brand'}? No email or invitation is required — the brand will be live immediately.`}
          handleConfirm={handleActive}
          loading={loading}
        />}

        {
          openModal && (
            // <AddUser
            //   loading={loading}
            //   setLoading={setLoading}
            //   openModal={openModal}
            //   handleModal={handleModal}
            //   getUsers={getUsers}
            // />
            <CreateBrand handleModal={handleModal} getUsers={getUsers} loading={loading} setLoading={setLoading} />
          )
        }
        {
          editModal && (
            // <EditBrand
            //   openModal={editModal}
            //   handleModal={handleEditModal}
            //   user={user}
            //   fileName={fileName}
            //   setFileName={setFileName}
            //   setUser={setUser}
            //   getUsers={getUsers}
            //   setLoading={setLoading}
            // />
            <EditBrandModal handleEditModal={handleEditModal} user={user} getUsers={getUsers} loading={loading} setLoading={setLoading} />
          )
        }
        {
          resetPassword && <ResetPassword handleModal={handlResetModal} user={user} />
        }
        {verifcationModal && <VerificationModal handleModal={handlVerificationModal} handleResendCode={handleResendCode} confirmVerification={handleConfirmVerification} loading={loading} />}
      </Container >
    </>
  );
};

export default Brands;
